import { jsx as r } from "react/jsx-runtime";
import { createContext as t, useMemo as i } from "react";
const s = t({
  width: window.innerWidth
});
function d({ width: o, children: e }) {
  const n = i(() => ({ width: o }), [o]);
  return /* @__PURE__ */ r(s.Provider, { value: n, children: e });
}
export {
  s as DimensionsContext,
  d as DimensionsProvider
};
